import React from 'react';
import root from 'window-or-global';
import render from 'react-render';

// Don't import any project code above index.scss as it must appear first in the CSS
import 'styles/index.scss';
// Ensure the browser is instrumented before all other imports
import 'utils/sentry';
import { getFeatureFlags } from 'utils/feature-flags';

import { createStoreAndHistory } from 'redux/create-store';
import initScrollRestorer from 'scroll-restorer';

import { addThirdpartyScriptProxies } from 'analytics/analytics-proxies';
import { clientHistory } from 'utils/history';
import { removeClientSideLegacyCookies } from 'utils/cookie';
import { addWebViewDialogEventListeners } from 'utils/webview/dialog';

import { readCookieConsentCookies } from 'redux/modules/cookies/actions';

import OnRouteChange from 'route-actions/RouteChange';
import preRenderActions from 'route-actions/pre-render-actions';

import AppComponent from 'components/App';

import 'setup-dev-browser';
import { initApmRum } from 'utils/apm-rum';

const { apmRum } = getFeatureFlags();

// This reference to the dataLayer is needed to make the main GTM script work. It's entirely reasonable
// to relocate to a better area though.
// eslint-disable-next-line no-restricted-properties
window.dataLayer = window.dataLayer || [];

initApmRum({ isEnabled: apmRum });
addThirdpartyScriptProxies();
addWebViewDialogEventListeners();
initScrollRestorer(clientHistory);

// eslint-disable-next-line no-underscore-dangle
const initialData = root.__PRELOADED_STATE__;
// eslint-disable-next-line no-underscore-dangle
if (initialData) root.__PRELOADED_STATE__ = true;

const { store, history } = createStoreAndHistory(clientHistory, initialData);

const renderApp = () =>
  render(
    <OnRouteChange>
      <AppComponent />
    </OnRouteChange>,
    history,
    store,
    root.document.getElementById('content'),
  );

const entryPoint = async () => {
  removeClientSideLegacyCookies();

  if (module.hot) {
    module.hot.accept();
  }

  store.dispatch(readCookieConsentCookies());

  try {
    await preRenderActions(store, true);
  } catch {
    // swallow, handled in middleware
  } finally {
    renderApp();
  }
};

entryPoint();
